import React, { useEffect, useState } from 'react';
import { Button, Modal, Row } from 'antd';
import { getPayTokenContract } from '../../common/smart-contracts/helpers/PayToken/PayToken';
import { formatEther, Typed } from 'ethers';
import { ETHPrice } from '../../common/payment-types.const';
import { roundOff } from '../../utils/roundOff';
import { convertScientificToNormal } from '../../utils/scientificToNormal';

interface PaymentDetails {
  userWallet: string | undefined;
  fee: string | undefined;
  ethPrice: ETHPrice | undefined;
  walletToTransferFundsTo: string | undefined;
  tokensToTransfer: string | undefined;
}

interface IComponentProps {
  closeModal: () => void;
  modalOpened: boolean;
  paymentDetails: PaymentDetails;
  onSubmit: () => Promise<void>;
}

export function PaymentConfirmationModal({ closeModal, modalOpened, paymentDetails, onSubmit }: IComponentProps) {
  const { userWallet, fee, ethPrice, walletToTransferFundsTo, tokensToTransfer } = paymentDetails;
  const [SoVBalance, setSoVBalance] = useState<string>('N/A');

  useEffect(() => {
    if (userWallet) {
      (async () => {
        const contract = await getPayTokenContract(userWallet);

        if (contract) {
          try {
            const balance = await contract.balanceOf(Typed.address(userWallet), 0);
            setSoVBalance(balance ? formatEther(balance) : '0');
          } catch (e) {
            setSoVBalance('N/A');
          }
        }
      })();
    }
  }, [userWallet]);

  return (
    <Modal
      title='Pay fee for transaction'
      footer={
        <Row style={{ width: '100%', justifyContent: 'center' }}>
          <Button type='primary' onClick={onSubmit}>
            Pay
          </Button>
          <Button onClick={closeModal}>Cancel</Button>
        </Row>
      }
      open={modalOpened}
      onCancel={closeModal}
    >
      <div className='grid-container'>
        <div className='grid-item'>
          <b>Wallet 1 (From):</b>
        </div>
        <div className='grid-item'>
          <span>{userWallet}</span>
        </div>
        <div className='grid-item'>
          <b>Wallet 1 Balance:</b>
        </div>
        <div className='grid-item'>
          <span>
            {ethPrice ? roundOff(convertScientificToNormal((parseFloat(SoVBalance) * ethPrice.USD).toString())) : 'N/A'}{' '}
            USD
          </span>
          <p>({SoVBalance} ETH)</p>
        </div>
        <div className='grid-item'>
          <b>Wallet 2 (To):</b>
        </div>
        <div className='grid-item'>
          <span>{walletToTransferFundsTo}</span>
        </div>
        <div className='grid-item'>
          <b>Tokens to Transfer:</b>
        </div>
        <div className='grid-item'>
          <span>
            {tokensToTransfer && ethPrice
              ? roundOff(convertScientificToNormal((parseFloat(tokensToTransfer) * ethPrice.USD).toString()))
              : 'N/A'}{' '}
            USD
          </span>
          <p>({tokensToTransfer} ETH)</p>
        </div>
        <div className='grid-item'>
          <b>Fee:</b>
        </div>
        <div className='grid-item'>
          {/* <span>
            {fee && ethPrice ? roundOff(convertScientificToNormal((parseFloat(fee) * ethPrice.USD).toString())) : 'N/A'}{' '}
            USD
          </span> */}
          <span>0.5 USD</span>
          <p>({fee} ETH)</p>
        </div>
      </div>
    </Modal>
  );
}
